import { Box, Grid } from '@mui/material';
import { Ribbon } from '@/data/types/Product';

export const ProductRibbons = ({ ribbons }: { ribbons: Ribbon[] }) => (
	<Grid
		sx={{
			position: 'absolute',
			top: '8px',
			left: '4px',
		}}
	>
		{ribbons[0]?.value ? (
			<Box
				sx={{
					mb: '4px',
					p: '2px 6px',
					color: 'white',
					fontSize: 'var(--font-size-small)',
					fontWeight: 'bold',
					textDecoration: 'none',
					textTransform: 'uppercase',
					backgroundColor: '#ff5524',
					borderRadius: '11px',
					width: 'auto',
					textAlign: 'center',
				}}
			>
				{`${ribbons[0].value}`}
			</Box>
		) : null}

		{ribbons[1]?.value ? (
			<Box
				sx={{
					p: '2px 6px',
					color: 'white',
					fontSize: 'var(--font-size-small)',
					fontWeight: 'bold',
					textDecoration: 'none',
					textTransform: 'uppercase',
					backgroundColor: '#AB2326',
					borderRadius: '11px',
					width: 'auto',
					textAlign: 'center',
				}}
			>
				{`${ribbons[1].value}`}
			</Box>
		) : null}
	</Grid>
);
